// Mock data for Zitelou Back Office

// Generate realistic French names
const firstNames = ['Jean', 'Marie', 'Pierre', 'Sophie', 'Luc', 'Claire', 'Thomas', 'Emma', 'Nicolas', 'Julie', 'Antoine', 'Camille', 'François', 'Léa', 'Alexandre', 'Chloé', 'Maxime', 'Laura', 'Julien', 'Sarah', 'Sébastien', 'Manon', 'David', 'Lisa', 'Vincent', 'Pauline', 'Olivier', 'Charlotte', 'Benjamin', 'Marine', 'Mathieu', 'Anaïs', 'Romain', 'Élise', 'Guillaume', 'Aurélie', 'Lucas', 'Justine', 'Raphaël', 'Morgane', 'Florian', 'Céline', 'Adrien', 'Mélanie', 'Simon', 'Laurie', 'Hugo', 'Caroline', 'Valentin', 'Nathalie'];

const lastNames = ['Dupont', 'Martin', 'Bernard', 'Thomas', 'Robert', 'Petit', 'Dubois', 'Richard', 'Garcia', 'Durand', 'Moreau', 'Lefebvre', 'Simon', 'Laurent', 'Michel', 'Leroy', 'Martinez', 'David', 'Fontaine', 'Rousseau', 'Vincent', 'Fournier', 'Morel', 'Girard', 'Andre', 'Lefevre', 'Mercier', 'Dupuis', 'Lambert', 'Bonnet', 'Francois', 'Garnier', 'Faure', 'Roussel', 'Blanc', 'Guerin', 'Muller', 'Henry', 'Roux', 'Clement', 'Gauthier', 'Chevalier', 'Perrin', 'Robin', 'Masson', 'Sanchez', 'Gerard', 'Nguyen', 'Boyer', 'Denis'];

const childrenFirstNames = ['Lucas', 'Emma', 'Louis', 'Léa', 'Gabriel', 'Chloé', 'Raphaël', 'Jade', 'Arthur', 'Louise', 'Hugo', 'Alice', 'Jules', 'Lina', 'Adam', 'Rose', 'Maël', 'Anna', 'Noah', 'Mila', 'Ethan', 'Léna', 'Paul', 'Zoé', 'Tom', 'Inès', 'Sacha', 'Juliette', 'Nathan', 'Manon', 'Victor', 'Camille', 'Léon', 'Sarah', 'Isaac', 'Eva', 'Timéo', 'Lola', 'Antoine', 'Lily'];

// Helper functions
const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
const getRandomDate = (start, end) => new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
const formatDate = (date) => date.toISOString().split('T')[0];

// Generate mock users
export const mockUsers = Array.from({ length: 60 }, (_, index) => {
  const firstName = getRandomElement(firstNames);
  const lastName = getRandomElement(lastNames);
  const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@email.com`;
  const createdAt = getRandomDate(new Date(2024, 0, 1), new Date(2025, 9, 24));
  const lastLogin = getRandomDate(createdAt, new Date(2025, 9, 24));
  const statuses = ['active', 'expired', 'suspended', 'cancelled'];
  const status = index < 45 ? 'active' : getRandomElement(statuses);

  const childCount = Math.floor(Math.random() * 3) + 1; // 1 to 3 children
  const children = Array.from({ length: childCount }, (_, childIndex) => ({
    id: index * 10 + childIndex + 1,
    firstname: getRandomElement(childrenFirstNames),
    lastname: lastName,
    birthdate: formatDate(getRandomDate(new Date(2013, 0, 1), new Date(2020, 11, 31))),
    contacts_count: Math.floor(Math.random() * 10) + 3,
    apps_count: Math.floor(Math.random() * 8) + 2,
  }));

  return {
    id: index + 1,
    firstname: firstName,
    lastname: lastName,
    email: email,
    phone: `+33 6 ${Math.floor(Math.random() * 90) + 10} ${Math.floor(Math.random() * 90) + 10} ${Math.floor(Math.random() * 90) + 10} ${Math.floor(Math.random() * 90) + 10}`,
    created_at: formatDate(createdAt),
    last_login: formatDate(lastLogin),
    subscription_status: status,
    children: children,
    ip_address: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
    logs: [
      {
        id: index * 5 + 1,
        date: formatDate(lastLogin),
        time: `${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
        action: 'Connexion',
        ip: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
        device: getRandomElement(['Mobile', 'Web', 'Tablet'])
      },
      {
        id: index * 5 + 2,
        date: formatDate(getRandomDate(createdAt, lastLogin)),
        time: `${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
        action: 'Modification contacts',
        ip: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
        device: getRandomElement(['Mobile', 'Web', 'Tablet'])
      },
      {
        id: index * 5 + 3,
        date: formatDate(getRandomDate(createdAt, lastLogin)),
        time: `${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
        action: 'Ajout application',
        ip: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
        device: getRandomElement(['Mobile', 'Web', 'Tablet'])
      }
    ]
  };
});

// Generate mock subscriptions
export const mockSubscriptions = mockUsers.map((user, index) => {
  const type = Math.random() > 0.35 ? 'monthly' : 'yearly';
  const amount = type === 'monthly' ? 9.99 : 99.99;
  const startDate = new Date(user.created_at);
  const nextBilling = new Date(startDate);

  if (type === 'monthly') {
    nextBilling.setMonth(nextBilling.getMonth() + 1);
  } else {
    nextBilling.setFullYear(nextBilling.getFullYear() + 1);
  }
  const statusMap = {
    'active': 'active',
    'expired': 'cancelled',
    'suspended': 'paused',
    'cancelled': 'cancelled'
  };
  const status = statusMap[user.subscription_status] || 'active';

  // Generate transaction history
  const transactionCount = Math.floor(Math.random() * 10) + 3;
  const transactions = Array.from({ length: transactionCount }, (_, txIndex) => {
    const txDate = new Date(startDate);
    if (type === 'monthly') {
      txDate.setMonth(txDate.getMonth() + txIndex);
    } else {
      txDate.setFullYear(txDate.getFullYear() + Math.floor(txIndex / 12));
      txDate.setMonth(txDate.getMonth() + (txIndex % 12));
    }

    const txStatus = Math.random() > 0.9 ? 'failed' : 'succeeded';

    return {
      id: `pi_${Math.random().toString(36).substring(2, 15)}`,
      date: formatDate(txDate),
      amount: amount,
      status: txStatus,
      payment_method: `Visa •••• ${Math.floor(Math.random() * 9000) + 1000}`
    };
  }).sort((a, b) => new Date(b.date) - new Date(a.date));

  return {
    id: `sub_${Math.random().toString(36).substring(2, 15)}`,
    stripe_id: `sub_${Math.random().toString(36).substring(2, 15)}`,
    user_id: user.id,
    user_name: `${user.firstname} ${user.lastname}`,
    type: type,
    amount: amount,
    currency: 'EUR',
    status: status,
    start_date: formatDate(startDate),
    next_billing: status === 'active' ? formatDate(nextBilling) : null,
    last_payment: transactions[0]?.date || formatDate(startDate),
    transactions: transactions
  };
});

// Generate statistics
const activeSubscriptions = mockSubscriptions.filter(s => s.status === 'active');
const totalRevenue = activeSubscriptions.reduce((sum, sub) => sum + sub.amount, 0);

export const mockStats = {
  total_users: mockUsers.length,
  active_subscriptions: activeSubscriptions.length,
  monthly_growth: 12.5,
  mrr: Math.round(totalRevenue * 100) / 100,
  new_users_30d: mockUsers.filter(u => {
    const created = new Date(u.created_at);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return created >= thirtyDaysAgo;
  }).length,
  cancelled_30d: mockSubscriptions.filter(s => {
    if (s.status !== 'cancelled') return false;
    const lastPayment = new Date(s.last_payment);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return lastPayment >= thirtyDaysAgo;
  }).length,
  conversion_rate: 55.2,
  churn_rate: 4.2,
  avg_subscription_duration: 8.5,
  monthly_subscriptions: mockSubscriptions.filter(s => s.type === 'monthly').length,
  yearly_subscriptions: mockSubscriptions.filter(s => s.type === 'yearly').length,
};

// Generate monthly growth data for charts
export const mockGrowthData = Array.from({ length: 12 }, (_, index) => {
  const date = new Date();
  date.setMonth(date.getMonth() - (11 - index));
  return {
    month: date.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }),
    users: Math.floor(Math.random() * 100) + 50 + index * 10,
    subscriptions: Math.floor(Math.random() * 80) + 40 + index * 8,
    revenue: Math.floor(Math.random() * 2000) + 1000 + index * 150,
  };
});

// Generate daily activity for last 30 days
export const mockActivityData = Array.from({ length: 30 }, (_, index) => {
  const date = new Date();
  date.setDate(date.getDate() - (29 - index));
  return {
    date: formatDate(date),
    new_users: Math.floor(Math.random() * 15) + 2,
    cancelled: Math.floor(Math.random() * 3),
  };
});

// Mock admin users
export const mockAdmins = [
  {
    id: 1,
    firstname: 'Admin',
    lastname: 'Principal',
    email: 'admin@zitelou.com',
    role: 'super_admin',
    created_at: '2024-01-15',
    last_login: '2025-10-24',
  },
  {
    id: 2,
    firstname: 'Support',
    lastname: 'Team',
    email: 'support@zitelou.com',
    role: 'support',
    created_at: '2024-03-20',
    last_login: '2025-10-23',
  },
  {
    id: 3,
    firstname: 'Gestionnaire',
    lastname: 'Abonnements',
    email: 'gestionnaire@zitelou.com',
    role: 'admin',
    created_at: '2024-06-10',
    last_login: '2025-10-22',
  }
];

// Mock system logs
export const mockSystemLogs = Array.from({ length: 100 }, (_, index) => {
  const date = getRandomDate(new Date(2025, 8, 1), new Date(2025, 9, 24));
  const actions = [
    'Connexion',
    'Modification utilisateur',
    'Suspension abonnement',
    'Résiliation abonnement',
    'Création utilisateur',
    'Consultation détails',
    'Export données',
    'Modification configuration'
  ];

  return {
    id: index + 1,
    admin_id: getRandomElement(mockAdmins).id,
    admin_name: `${getRandomElement(mockAdmins).firstname} ${getRandomElement(mockAdmins).lastname}`,
    action: getRandomElement(actions),
    target: `User #${Math.floor(Math.random() * 60) + 1}`,
    ip: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
    date: formatDate(date),
    time: `${Math.floor(Math.random() * 24).toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
  };
}).sort((a, b) => new Date(b.date + ' ' + b.time) - new Date(a.date + ' ' + a.time));

// Mock cancellation reasons
export const mockCancellations = [
  { date: '2025-10-23', parent: 'Marie Martin', duration: '3 mois', reason: 'Prix élevé', type: 'Mensuel' },
  { date: '2025-10-22', parent: 'Pierre Dupont', duration: '6 mois', reason: 'Changement de téléphone', type: 'Mensuel' },
  { date: '2025-10-20', parent: 'Sophie Bernard', duration: '2 mois', reason: 'Fonctionnalités insuffisantes', type: 'Mensuel' },
  { date: '2025-10-18', parent: 'Luc Thomas', duration: '12 mois', reason: 'Enfant trop grand', type: 'Annuel' },
  { date: '2025-10-15', parent: 'Claire Robert', duration: '4 mois', reason: 'Application concurrente', type: 'Mensuel' },
  { date: '2025-10-12', parent: 'Thomas Petit', duration: '8 mois', reason: 'Problèmes techniques', type: 'Mensuel' },
  { date: '2025-10-10', parent: 'Emma Dubois', duration: '5 mois', reason: 'Prix élevé', type: 'Mensuel' },
  { date: '2025-10-08', parent: 'Nicolas Richard', duration: '11 mois', reason: 'Satisfaction', type: 'Annuel' },
];

const mockDataExport = {
  mockUsers,
  mockSubscriptions,
  mockStats,
  mockGrowthData,
  mockActivityData,
  mockAdmins,
  mockSystemLogs,
  mockCancellations,
};

export default mockDataExport;
